import { createSlice } from "@reduxjs/toolkit";
import { FetchTestBarcode } from "./barcodeAction";

interface BarcodeState {
  barcode: any | null;
  loading: boolean;
  error: string | null;
}

const initialState: BarcodeState = {
  barcode: null,
  loading: false,
  error: null,
};

const barcodeSlice = createSlice({
  name: 'barcode',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(FetchTestBarcode.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FetchTestBarcode.fulfilled, (state, { payload }) => {
        state.loading = false;
        // state.barcode = payload.data; // Store barcode details
      })
      .addCase(FetchTestBarcode.rejected, (state, { payload }) => {
        state.loading = false;
        state.error =
          (payload as { responseMessage?: string })?.responseMessage || "Failed to fetch barcode details";
      });
  },
});

export const barcodeReducer = barcodeSlice.reducer;
